// extracted by mini-css-extract-plugin
export default {"card":"retreatCard_card__nMMoJ","img":"retreatCard_img__por+6","price":"retreatCard_price__x9WPj"};